import { FILE_DIALOG_TABS } from '@/helpers/const';

export default () => ({
  showMyBooks: false,
  activeFileDialogTab: FILE_DIALOG_TABS.IMAGE_BANK,
  imageBankTabIdChain: [],
});
